import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

const getFundRatesUrl = (id: string) => buildEndpoint(['fundrates'], [{ key: 'id', value: id }]);

export interface Rate {
    date: string;
    nav: number;
    bidPrice: number;
    askPrice: number;
}

export interface GetFundRatesResponse {
    fundId: number;
    rates: Rate[];
}

export const getFundRatesApiCall = (id: string) => apifetch<GetFundRatesResponse>(getFundRatesUrl(id), 'GET');

/** Default: rates last 100 years */
export const useGetFundRates = (
    id: string | undefined,
    startDate: DateTime = DateTime.now().minus({ years: 100 }),
    endDate: DateTime = DateTime.now(),
) => {
    const startDateFormatted = startDate.toFormat('yyyy-MM-dd');
    const endDateFormatted = endDate.toFormat('yyyy-MM-dd');

    const getFundRatesQuery = useQuery<GetFundRatesResponse>(
        ['fundrates', id, startDateFormatted, endDateFormatted],
        async () => {
            const getRates = await getFundRatesApiCall(id!);
            return getRates();
        },
        {
            enabled: id !== undefined,
        },
    );

    return getFundRatesQuery;
};
